import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const TeamCellComponent = ({ value }) => {
  // Handle null or undefined value
  if (!value) {
    return <div css={styles.container}></div>
  }

  // Handle custom events
  if (value.isCustomEvent) {
    const { event } = value;

    // Make sure to display matchName for custom events
    const eventName = event?.matchName || event?.tournamentDTO?.tournamentName || 'Event';

    return (
      <div css={styles.customEventContainer}>
        <div css={styles.textContainer}>
          <Text size={12} bold>
            {eventName}
          </Text>
        </div>
      </div>
    )
  }

  // Handle regular team-based events - show both teams with a separator
  const { teamA, teamB, teamOneObj, teamTwoObj } = value;

  return (
    <div css={styles.teamsContainer}>
      {/* First Team */}
      <div css={styles.teamSection}>
        {teamOneObj?.logo ? (
          <Margin right={1}>
            <InWinImage
              source={teamOneObj.logo}
              alt={teamA}
              css={styles.logo}
            />
          </Margin>
        ) : (
          <Margin right={1}>
            <div css={styles.imagePlaceholder} />
          </Margin>
        )}
        <div css={styles.textContainer}>
          <Text size={11}>
            {teamA || ''}
          </Text>
        </div>
      </div>

      {/* Separator */}
      <div css={styles.separator}>
        <Text size={11} bold>vs</Text>
      </div>

      {/* Second Team */}
      <div css={styles.teamSection}>
        {teamTwoObj?.logo ? (
          <Margin right={1}>
            <InWinImage
              source={teamTwoObj.logo}
              alt={teamB}
              css={styles.logo}
            />
          </Margin>
        ) : (
          <Margin right={1}>
            <div css={styles.imagePlaceholder} />
          </Margin>
        )}
        <div css={styles.textContainer}>
          <Text size={11}>
            {teamB || ''}
          </Text>
        </div>
      </div>
    </div>
  )
}

TeamCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export { TeamCellComponent }
